import * as angular from 'angular';
import { TooltipState } from './tooltip-state';

class TooltipComponent implements ng.IComponentController {
    state: TooltipState;
    message: string;
}

angular
    .module('naut')
    .component('tooltip', {
        controller: TooltipComponent,
        bindings: {
            'state': '<',
            'message': '<',
        },
        template: require('./tooltip.component.html')
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/inventory/components/import-tab/tooltip.component.ts